<template>
  <div class="staff">
<!--    <el-card>-->
<!--      <el-breadcrumb separator="/">-->
<!--        <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>权限管理</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>角色管理</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </el-card>-->
    <main class="content">
      <el-card>
        <el-form :inline="true" :model="searchForm" size="mini">
          <el-form-item label="角色名">
            <el-input v-model="searchForm.name" placeholder="角色名" size="mini" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="角色状态" size="mini" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="无效" value="0"></el-option>
              <el-option label="有效" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
          </el-form-item>
        </el-form>
        <div ref="tablePosition"></div>
        <el-table
          stripe
          size="mini"
          :data="tableData"
          v-loading="loading"
          :height="tableConfig.height"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="角色名">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="100">
            <template slot-scope="scope">
              <el-tag
                  :type="scope.row.status ===  1 ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.status === 1 ? "有效" : "无效" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350" align="right">
                <template slot="header">
                    <el-button type="primary" @click="handleCreate" size="mini">添加</el-button>
                </template>
              <template slot-scope="scope">
                  <el-button
                      size="mini" type="text"
                      @click="handleEditModel(scope.$index, scope.row)">编辑模块</el-button>
                  <el-divider direction="vertical" ></el-divider>
                  <el-button
                      size="mini" type="text"
                      @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
                  <el-divider direction="vertical" ></el-divider>
                  <el-button
                      size="mini"
                      type="text" style="color:red;"
                      @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;padding-top: 20px">
          <el-pagination
              background
              layout="sizes,prev, pager, next"
              :page-sizes="[10, 20, 50, 100]"
              v-if="total>0"
              :total="total"
              :page-size="pageSize"
              @size-change="handleSizeChange"
              @current-change="onPageChange"
              :current-page="currentPage"
              @prev-click="onPageChange"
              @next-click="onPageChange">
          </el-pagination>
        </div>
      </el-card>
    </main>
    <el-dialog title="角色信息" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
        <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
            <el-form-item label="角色名" prop="name">
                <el-input v-model="editForm.name" placeholder="请输入角色名" clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="editForm.status" placeholder="请选择角色状态" clearable>
                    <el-option label="无效" value="0"></el-option>
                    <el-option label="有效" value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="设置权限" :visible.sync="editModuleDialogVisible" width="500px" :close-on-click-modal="false">
        <el-tree
            :props="props"
            :data="models"
            ref="tree"
            v-loading="treeLoading"
            node-key="id"
            show-checkbox
            accordion>
        </el-tree>
        <div slot="footer" class="dialog-footer">
            <el-button @click="editModuleDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onModelSubmit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            searchForm: {
                name: "",
                status: "",
            },
            statusOptions: [
                {
                    value: "",
                    label: "全部",
                },
                {
                    value: "0",
                    label: "无效",
                },
                {
                    value: "1",
                    label: "有效",
                },
            ],
            props: {
                id: "id",
                label: 'name',
                children: 'children',
                isLeaf: 'leaf'
            },
            models: {},
            loading: false,
            treeLoading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editModuleDialogVisible: false,
            editForm: {
                id: "",
                name: "",
                status: "1",
            },
            rid: "",
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        load(node, resolve) {
            let fid;
            this.loading = true;
            let _this = this;
            if(node.level === 0) {
                fid = "root"
            } else {
                fid = node.data.id
            }
            this.$axios.post("/admin/rights/model/list", {
                fid: fid,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    for(let i=0; i<resp.data.length; i++) {
                        if(resp.data[i].type == 1) {
                            resp.data[i].disabled = false
                        } else {
                            resp.data[i].disabled = true
                        }
                    }
                    resolve(resp.data);
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
                _this.loading = false;
            }).catch(function() {
                _this.loading = false;
            });
        },
        onSearch() {
            let role = {
            };
            if(this.searchForm.name != "") {
                role["name"] = this.searchForm.name;
            }
            if(this.searchForm.status != "") {
                role["status"] = this.searchForm.status;
            }

            this.loading = true;
            let _this = this
            this.$axios.post("/admin/rights/role/search",{
                cond: role,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
                _this.loading = false;
            });
        },
        handleCreate() {
            this.editForm.id = "";
            this.editForm.name = "";
            this.editForm.status = "1";
            this.editDialogVisible = true;
        },
        onSubmit() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/rights/role", this.editForm)
                    .then(function(response){
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editDialogVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        onModelSubmit() {
            let _this = this;
            let modelChecked = this.$refs.tree.getCheckedKeys();
            this.$axios.post("/admin/rights/role/bindModel", {
                rid: this.rid,
                mids: modelChecked,
            })
            .then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.editModuleDialogVisible = false;
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEditModel(index, row) {
            this.rid = row.id;
            this.editModuleDialogVisible =  true;
            let _this = this;
            this.treeLoading = true;
            this.$axios.get("/admin/rights/role/findAllApi/" + this.rid)
            .then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$refs.tree.setCheckedKeys(resp.data)
                }
                _this.treeLoading = false;
            }).catch(function() {
                _this.treeLoading = false;
            });
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.name = row.name;
            this.editForm.status = row.status + "";
            this.editDialogVisible = true;
        },
        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除角色【' + row.name + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/rights/role/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        initModels() {
            let _this = this;
            this.$axios.get("/admin/rights/model/all").then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.models = resp.data;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch();
        this.initModels();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>